// import moment from 'moment';
import {
  call,
  put,
  // select,
} from 'redux-saga/effects';
// import nsUtils from '@netsapiens/netsapiens-js/dist/utils';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsToken from '@netsapiens/netsapiens-js/dist/token';

import {
  setLoading, setUnreadCount,
} from '../../../state/chat/chatSlice';
import fetchMessageSession from '../fetchMessageSession/fetchMessageSession';

export default function* markRead({ payload }) {
  const debug = false;

  const { session } = payload;

  const decodedToken = nsToken.getDecoded();

  if (debug) {
    console.debug('this is markRead to post: ', {
      object: 'messagesession',
      action: 'update',
      domain: decodedToken.domain,
      user: decodedToken.user,
      session_id: session.id,
      last_status: 'read',
    });
  }

  const res = yield nsApi.post({
    object: 'messagesession',
    action: 'update',
    domain: decodedToken.domain,
    user: decodedToken.user,
    session_id: session.id,
    last_status: 'read',
  }, {
    object: 'messagesession',
    action: 'update',
    domain: decodedToken.domain,
    user: decodedToken.user,
    session_id: session.id,
    last_status: 'read',
  });

  if (debug) console.debug('this is markRead res: ', res);

  // fetch the new updated message session after the update
  yield call(fetchMessageSession, { sessionId: session.id });

  const messageSessions = yield call(nsApi.get, {
    object: 'messagesession',
    action: 'read',
    user: decodedToken.user,
    domain: decodedToken.domain,
    format: 'json',
  });

  let unreadCount = 0;
  // console.debug('this is res: ', res);
  if (messageSessions) {
    for (let i = 0; i < messageSessions.length; i += 1) {
      if (messageSessions[i].session_id && messageSessions[i].session_id.includes('meeting')) {
        continue; // eslint-disable-line no-continue
      }

      if (messageSessions[i].last_status !== 'read') {
        unreadCount += 1;
      }
    }
  }
  yield put(setUnreadCount(unreadCount));

  yield put(setLoading(false));
  if (debug) console.debug('at the end of markRead');
}
